import * as actions from 'client/actions/actionsManagement'
import useManagement from 'client/hooks/useManagement'
import { selectors as managementSelectors } from 'client/reducers/managementReducer'
import { useActions } from 'common/hooks/useActions'
import React, { KeyboardEvent, MouseEvent } from 'react'
import { twMerge } from 'tailwind-merge'

export const Overlay = () => {
  const isSomethingEditing = useManagement(
    managementSelectors.isSomethingEditing,
  )
  const isPopupEditing = useManagement(managementSelectors.isPopupActive)
  const isPageEditing = useManagement(managementSelectors.isPageEditing)

  const toggleSettings = useActions(actions.toggleSettings)
  const setActiveSidebarTab = useActions(actions.setActiveSidebarTab)
  const toggleActivePopup = useActions(actions.toggleActivePopup)

  const handleHide = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (isSomethingEditing) {
      toggleSettings(null)
    } else {
      toggleActivePopup(null)
      setActiveSidebarTab(null)
    }
  }

  const handleKeyUp = (e: KeyboardEvent<HTMLDivElement>) => {
    handleHide(e as unknown as MouseEvent<HTMLDivElement>)
    return
  }

  const enabled = isSomethingEditing || isPageEditing || isPopupEditing

  return (
    enabled && (
      // biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
      <div
        onClick={handleHide}
        onKeyUp={handleKeyUp}
        className={twMerge(
          'absolute top-0 left-0 h-full w-full bg-transparent',
          isPopupEditing && isSomethingEditing ? 'z-50' : 'z-10',
        )}
      >
        <div className="pointer-events-none h-[inherit]" />
      </div>
    )
  )
}
